import InvoiceTypes from '../dynamics/invoice-types'
export const getInvoiceTypeById = (typeId) => InvoiceTypes.find(({ id }) => id === typeId)